import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "main",
    { staticClass: "doctors-register-content pt-2" },
    [
      _c("div", { class: { "b-container": !_setup.isMobile } }, [
        _c(
          "h1",
          {
            staticClass: "text--text mb-sm-6 mb-4",
            class: _setup.isMobile ? "text-h6 px-2" : "text-h5",
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_setup.t("Регистрация клиники", _setup.options)) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-column gr-md-16 gr-sm-12 gr-8 doctors-register-content__content",
            class: { "px-2": _setup.isMobile },
          },
          [
            _setup.context.subject
              ? _c(_setup.RegistrationForm, {
                  class: { "elevation-1 rounded-sm pa-12": !_setup.isMobile },
                  attrs: {
                    "is-doctor": _setup.context.is_doctor,
                    "is-lpu": _setup.context.is_lpu,
                    "date-of-sending-email": _setup.context.busy,
                    "user-email": _setup.context.usr?.user?.email,
                    "phone-confirmation-on-doctor-register":
                      _setup.context.site_settings
                        .phone_confirmation_on_doctor_register,
                    subject: _setup.context.subject,
                  },
                })
              : _c(_setup.HowToRegister, {
                  class: { "elevation-1 rounded-sm pa-12": !_setup.isMobile },
                }),
            _vm._v(" "),
            _setup.isMobile ? _c(VDivider) : _vm._e(),
            _vm._v(" "),
            _c(_setup.BenefitsOfRegistration, {
              class: { "elevation-1 rounded-sm pa-12": !_setup.isMobile },
            }),
            _vm._v(" "),
            _setup.isMobile ? _c(VDivider) : _vm._e(),
            _vm._v(" "),
            _c(_setup.AdvantagesOfSite),
            _vm._v(" "),
            !_setup.isMobile && _setup.context.request.country.is_russia
              ? [_c(_setup.MediaList), _vm._v(" "), _c(_setup.OurPartners)]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _setup.isMobile && _setup.context.request.country.is_russia
        ? [
            _c(VDivider, { staticClass: "mt-md-16 mt-sm-12 mt-8" }),
            _vm._v(" "),
            _c(_setup.MediaList, { staticClass: "mt-md-16 mt-sm-12 mt-8" }),
            _vm._v(" "),
            _c(_setup.OurPartners, { staticClass: "mt-md-16 mt-sm-12 mt-8" }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }